import React, { PropsWithChildren, useEffect, useRef } from "react";
import { CgClose } from "react-icons/cg";

type ModalProps = {
  onClose: () => void;
  active: Boolean;
  title: string;
};

export const ModalContainer: React.FC<PropsWithChildren<ModalProps>> = ({ onClose, children, active, title }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  const handleEscape = (event: KeyboardEvent) => {
    if (event.key === "Escape") onClose();
  };

  const handleBackdropClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) onClose();
  };

  useEffect(() => {
    document.addEventListener("keydown", handleEscape);
    modalRef.current?.addEventListener("click", handleBackdropClick);
    return () => {
      document.removeEventListener("keydown", handleEscape);
      modalRef.current?.removeEventListener("click", handleBackdropClick);
    };
  }, []);

  return (
    <div
      className={`${active ? "backdrop-blur-sm" : ""} fixed z-10 inset-0 p-3 flex items-center justify-center transition`}
      ref={modalRef}
    >
      <div
        className={`${active ? "opacity-100 scale-100" : "scale-95 opacity-0"} relative p-6 bg-gray-50 rounded-md w-full drop-shadow-md transition max-w-lg`}
      >
        <div className="absolute z-10 top-2 right-2">
          <button className="ml-auto p-2 text-lg" onClick={onClose}>
            <CgClose />
          </button>
        </div>
        {title && <div className="text-lg mb-2">{title}</div>}
        {children}
      </div>
    </div>
  );
};
